export type ParsedQueryString = {
  [key: string]: string;
};

// TODO: there's a bug if e.g. '?x=1&x=2' it parses to { x:'2' } instead of {x: ['1','2']}
export function parseQueryString<T extends ParsedQueryString>(search: string): T {
  return Object.fromEntries(new URLSearchParams(search).entries()) as T;
}
